!function(){
    function decodeContent(content) {
        try {
            return decodeURIComponent(window.atob(content).replace(/\+/g, "%20"));
        } catch (error) {
            console.error("Unable to decode obfuscated content", error);
            return "";
        }
    }

    function replaceElementWithHtml(element, html) {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = html;

        if (wrapper.childNodes.length > 0) {
            element.replaceWith(...wrapper.childNodes);
            return;
        }

        element.remove();
    }

    function renderEncodedContent(element) {
        const content = element.getAttribute("data-content");

        if (!content) {
            return;
        }

        const html = decodeContent(content);

        if (element.getAttribute("data-obfuscate-mode") === "fill") {
            element.innerHTML = html;
            element.removeAttribute("data-content");
            return;
        }

        replaceElementWithHtml(element, html);
    }

    function renderObfuscatedContent() {
        document.querySelectorAll(".js-obfuscated-content").forEach((element) => {
            if (element.hasAttribute("data-content")) {
                renderEncodedContent(element);
                return;
            }
        });
    }

    function initObfuscatedContent() {
        renderObfuscatedContent();

        if (document.documentElement.classList.contains("obfuscated-content-ready")) {
            return;
        }

        document.documentElement.classList.add("obfuscated-content-ready");

        const productTabs = document.querySelector("w3-product-tabs");

        if (!productTabs) {
            return;
        }

        new MutationObserver(() => {
            renderObfuscatedContent();
        }).observe(productTabs, {childList: true, subtree: true});
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initObfuscatedContent);
        return;
    }

    initObfuscatedContent();
}();